export default "__VITE_ASSET__5LwBwWPB__"